import { ArrowDown } from "lucide-react";
import { SITE, SECTIONS } from "@/config/sections";
import { HOME } from "@/constants/testIds";

export const Hero = () => (
  <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
    <div className="lg:col-span-7 fade-up">
      <span className="inline-block text-xs font-medium uppercase tracking-[0.2em] text-[#2C5242] bg-[#E8F0EC] px-3 py-1 rounded-full">
        {SITE.domain}
      </span>
      <h1 data-testid={HOME.heroTitle} className="font-heading mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] text-[#1C1917]">
        Welcome home, <span className="text-[#E06D44]">pet lovers.</span>
      </h1>
      <p className="mt-6 text-base md:text-lg text-stone-600 max-w-xl">
        {SITE.tagline} Shop treats and tough toys, grab the free new-pet guide, or order a memorial portrait, all in one place.
      </p>
      <a
        href="#sections"
        data-testid={HOME.heroExploreButton}
        className="mt-10 inline-flex items-center gap-2 bg-[#1C1917] text-white px-7 py-4 rounded-full font-medium hover:bg-[#E06D44] transition-colors duration-300"
      >
        Explore the {SECTIONS.length} sections <ArrowDown size={18} />
      </a>
    </div>
    <div className="lg:col-span-5 relative fade-up" style={{ animationDelay: "150ms" }}>
      <div className="absolute -inset-4 bg-[#E8F0EC] rounded-[2.5rem] rotate-3" />
      <img
        src={SITE.heroImage}
        alt="Kiddee, PetTok Shop's chief toy tester"
        className="relative w-full aspect-[4/5] object-cover rounded-[2rem] shadow-xl"
      />
    </div>
  </section>
);
